@if (initialized) {
  <div class="container job-personalized-campaign-message-dialog">
    <h1 mat-dialog-title class="text-center">Create Personalized Job Campaign Message</h1>
    <mat-dialog-content>
      <form class="personalized-campaign-message-form full-width">
        <div class="flex-grid wrap space-between font-15">
          <div class="message-form-accordion-wrapper">
            <mat-accordion class="full-width active-type-accordion" multi="false">
              <mat-expansion-panel [expanded]="activeMessageType === 'sms'" (opened)="setNeededData('sms')">
                <mat-expansion-panel-header>
                  <mat-panel-title> Personalized SMS Message </mat-panel-title>
                  <mat-panel-description>
                    <span>{{ currentMessageData?.sms_panel_description || default_sms_panel_description }}</span>
                    @if (smsSegmentInfo?.nonGsmCharacters?.length) {
                      <span class="danger">&nbsp;- Warning: Contains invalid GSM characters</span>
                    }
                  </mat-panel-description>
                </mat-expansion-panel-header>
                @if (smsSegmentInfo?.nonGsmCharacters?.length) {
                  <div class="gsm-description">
                    Non-GSM Characters triple the cost of a message to be sent, so we'd rather they not be in this message.
                  </div>
                }
                <ng-container *ngTemplateOutlet="variablePicker"></ng-container>
                <div class="type-panel-content full-width">
                  @if (smsSegmentInfo?.segmentsRequired > 3) {
                    <div class="segment-counter">
                      <strong>Over the suggested maximum limit.</strong>
                      <!-- <strong *ngIf="smsSegmentInfo?.segmentsRequired >= 5" class="isError">Message too long! Cannot use when sending.</strong> -->
                    </div>
                  }
                  @if (smsSegmentInfo?.nonGsmCharacters && smsSegmentInfo?.nonGsmCharacters?.length) {
                    <div class="non-gsm-chars danger">
                      Non GSM Characters detected. Please remove these: <pre>{{ smsSegmentInfo.nonGsmCharacters }}</pre>
                    </div>
                  }
                  <mat-form-field appearance="outline">
                    <mat-label>Message</mat-label>
                    <textarea #smsMessage matInput placeholder="Message" [(ngModel)]="currentMessageData.sms_text" name="sms_text" (keyup)="showSegmentInfo()" (change)="showSegmentInfo()"></textarea>
                  </mat-form-field>
                </div>
              </mat-expansion-panel>
              <mat-expansion-panel [expanded]="activeMessageType === 'email'" (opened)="setNeededData('email')">
                <mat-expansion-panel-header>
                  <mat-panel-title> Personalized Email Message </mat-panel-title>
                  <mat-panel-description>
                    <span>{{ currentMessageData?.email_panel_description || default_email_panel_description }}</span>
                  </mat-panel-description>
                </mat-expansion-panel-header>
                <div class="email-subject-content full-width">
                  <mat-form-field appearance="outline">
                    <mat-label>Subject</mat-label>
                    <input matInput placeholder="Subject" [(ngModel)]="currentMessageData.email_subject" name="email_subject" (keyup)="checkForm()">
                  </mat-form-field>
                </div>
                <ng-container *ngTemplateOutlet="variablePicker"></ng-container>
                <ng-template matExpansionPanelContent>
                  <div class="type-panel-content full-width">
                    <div class="ckeditor-wrapper no-border">
                      <html-editor [currentBody]="currentMessageData.email_html" [listenToChangeEvents]="true" (htmlEditorContentsChanged)="htmlEditorChanged($event)"></html-editor>
                    </div>
                  </div>
                </ng-template>
              </mat-expansion-panel>
            </mat-accordion>
          </div>
        </div>

        <section class="options-section full-width">
          <h3 class="options-heading">Options</h3>
          <div class="option-row" [class.is-on]="currentMessageData.personalized_bypass_7_day_rule">
            <div class="option-text">
              <div class="option-label">
                <mat-icon class="row-glyph">schedule</mat-icon>
                <span>Bypass 7-day rule</span>
              </div>
              <div class="option-description">
                Recipients you've contacted in the last 7 days will still receive this campaign.
              </div>
            </div>
            <mat-slide-toggle
              [(ngModel)]="currentMessageData.personalized_bypass_7_day_rule"
              name="personalized_bypass_7_day_rule"
              color="warn">
            </mat-slide-toggle>
          </div>
          <div class="option-row" [class.is-on]="currentMessageData.personalized_is_urgent">
            <div class="option-text">
              <div class="option-label">
                <mat-icon class="row-glyph">bolt</mat-icon>
                <span>Mark as urgent</span>
              </div>
              <div class="option-description">
                Bumps priority in the send queue. Use sparingly.
              </div>
            </div>
            <mat-slide-toggle
              [(ngModel)]="currentMessageData.personalized_is_urgent"
              name="personalized_is_urgent"
              color="warn">
            </mat-slide-toggle>
          </div>
        </section>

        <!-- Shared picker used in each expansion panel -->
        <ng-template #variablePicker>
          <div class="default-flex full-width variable-picker">
            <div class="variable-field variable-module">
              @if (filteredModules) {
                <div class="form-field">
                  <mat-form-field appearance="outline" class="special-height">
                    <mat-label>Module</mat-label>
                    <mat-select placeholder="Variable Type" [(ngModel)]="currentMessageData.variable_module" name="variable_module" [compareWith]="_sharedUtilsService.compareObjectsOrIDs" (selectionChange)="updateModuleFields($event.value)">
                      @for (_module of filteredModules; track _module) {
                        <mat-option [value]="_module">
                          {{ _module?.label }}
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
              }
            </div>
            <div class="variable-field variable-module-field">
              <div class="form-field">
                <mat-form-field appearance="outline" class="special-height">
                  <mat-label>Field</mat-label>
                  <mat-select placeholder="Field" [(ngModel)]="currentMessageData.variable_field" name="variable_field" (selectionChange)="updateVariable($event.value)">
                    @for (_field of moduleFields; track _field) {
                      <mat-option [value]="_field">
                        {{ _field?.label }}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <div class="variable-field variable-name">
              <div class="form-field">
                <mat-form-field appearance="outline" class="special-height">
                  <mat-label>Variable</mat-label>
                  <input matInput placeholder="Variable" [(ngModel)]="currentMessageData.variable" name="variable" readonly>
                </mat-form-field>
              </div>
            </div>
            <button type="button" class="insert-btn" mat-stroked-button color="primary" (click)="insertCurrentVariable()" [disabled]="!currentMessageData?.variable?.length">Insert</button>
            <button type="button" class="template-dialog-btn" mat-stroked-button color="primary" (click)="showTemplatePicker()">Use Template</button>
          </div>
        </ng-template>
      </form>
    </mat-dialog-content>
    <mat-dialog-actions class="pin-to-bottom">
      <button mat-button mat-dialog-close (click)="cancel()">Cancel</button>
      <button mat-raised-button color="primary" (click)="saveMessage()" [disabled]="!validMessageData">Save</button>
    </mat-dialog-actions>
  </div>
}